import type {Location} from 'react-router-dom'

import {queryToObject} from '../../../utils/queryParams'

export enum InvestigationStatusFilter {
  ALL = 'all',
  INVESTIGATED = 'investigated',
  NOT_INVESTIGATED = 'notInvestigated',
}
type InvestigationFilter = {
  key: InvestigationStatusFilter
  label: string
}
export const investigationFilterItems: InvestigationFilter[] = [
  {key: InvestigationStatusFilter.ALL, label: 'All'},
  {key: InvestigationStatusFilter.INVESTIGATED, label: 'Investigated'},
  {key: InvestigationStatusFilter.NOT_INVESTIGATED, label: 'Not investigated'},
]

export const getInvestigatedQueryParam = (location: Location): InvestigationStatusFilter => {
  const {investigated} = queryToObject(location.search)
  return investigated === 'false'
    ? InvestigationStatusFilter.NOT_INVESTIGATED
    : investigated === 'true'
    ? InvestigationStatusFilter.INVESTIGATED
    : InvestigationStatusFilter.ALL
}
